import { Immutable } from "immer";
import React from "react";

import { Link } from "../../../components/Link";
import { IProduct } from "../../../models/catalogue";
import { getOptionValueDisplayName } from "../../../utils/catalogue";
import { listOptions } from "./utils";

import styles from "./common.module.scss";

export const BasketLineTitle = (
    props: Immutable<{
        product: IProduct;
        additionalCSSClass?: string;
    }>,
): React.ReactNode => {
    let title = props.product.parent
        ? props.product.parent.title
        : props.product.title;
    if (props.product.parent) {
        const titleOptions = listOptions(props.product)
            .filter((option) => option.key !== "option_color")
            .map((option) => getOptionValueDisplayName(option))
            .filter((name) => !!name)
            // TODO(i18n): Don't hardcode ", " separator - different languages use different list separators. Consider using Intl.ListFormat or a translatable format string.
            .join(", ");
        if (titleOptions) {
            // TODO(i18n): Don't concatenate strings with hardcoded ", " - word order and punctuation vary by language. Use a translatable format like t`${title}, ${titleOptions}` to keep the complete phrase together.
            title = title + ", " + titleOptions;
        }
    }
    // Prefer the variant's own link (which includes the `/v/{id}/` suffix so
    // the PDP lands on the correct variant), falling back to the parent's link.
    const productLink =
        props.product.link ??
        (props.product.parent ? props.product.parent.link : null);

    return (
        <h2 className={`${styles.productTitle} ${props.additionalCSSClass}`}>
            {productLink ? (
                <Link href={productLink} target="_top">
                    {title}
                </Link>
            ) : (
                <>{title}</>
            )}
        </h2>
    );
};
